// extracted by mini-css-extract-plugin
module.exports = {"inline":"style_inline__2frGR"};